import { createLocalProjectStore, type LocalProjectStore } from '../../shared/api/local-projects';

let store: LocalProjectStore | null = null;

/** The IndexedDB project store (created on first use). */
export const local = (): LocalProjectStore => (store ??= createLocalProjectStore());
